import { PropsWithChildren } from 'react';

interface IProps {
	label?: string;
	onChange: (filterName: string, filterValue?: string, isFilter?: boolean) => void;
	checked?: boolean;
}

export function CheckBox({ label, onChange, checked }: PropsWithChildren<IProps>) {
	return (
		<div className="form__field">
			<label className="form__lbl-container">
				<input
					type="checkbox"
					className="form__input form__input--checkbox"
					onChange={() => onChange('PositionSchedule', label)}
					checked={checked}
				/>
				<span className="form__lbl--text">{label}</span>
			</label>
		</div>
	);
}
